/**
 * 在 data 中把 oldId 全部替换为 newId（仅遍历 schema 声明的字段）。
 *
 * 命中字段类型：
 *  - file / photo（值是 number[] 或单个 number）
 *  - signature（值是单个 number）
 *  - checklist 的每条 clause.attachments（number[]）
 *  - table 的 signature 列（每行該格值是单个 number）
 *
 * 其他字段（text/number/select/...）原样保留。
 */
export function replaceFileIdInData(schema, data, oldId, newId) {
    const next = { ...data };
    // 兜底：schema.sections 缺失視為空表單，原樣返回 data 副本（無欄位可替換）。
    for (const section of schema.sections ?? []) {
        for (const field of section.fields) {
            const v = next[field.id];
            if (field.type === 'file' || field.type === 'photo' || field.type === 'signature') {
                if (Array.isArray(v)) {
                    const replaced = v.map((x) => (x === oldId ? newId : x));
                    if (replaced.some((x, i) => x !== v[i])) {
                        next[field.id] = replaced;
                    }
                }
                else if (typeof v === 'number' && v === oldId) {
                    // 单值（簽名 / 单选附件）：直接替换
                    next[field.id] = newId;
                }
                continue;
            }
            if (field.type === 'checklist') {
                if (v && typeof v === 'object' && !Array.isArray(v)) {
                    const cloned = {};
                    let changed = false;
                    for (const [clauseId, cv] of Object.entries(v)) {
                        const atts = cv?.attachments;
                        if (Array.isArray(atts)) {
                            const replaced = atts.map((x) => (x === oldId ? newId : x));
                            if (replaced.some((x, i) => x !== atts[i])) {
                                cloned[clauseId] = { ...cv, attachments: replaced };
                                changed = true;
                                continue;
                            }
                        }
                        cloned[clauseId] = cv;
                    }
                    if (changed) {
                        next[field.id] = cloned;
                    }
                }
                continue;
            }
            if (field.type === 'table') {
                // table 的 signature 列：逐行替換該格 fileId；其餘列原樣保留
                const sigCols = field.columns.filter((c) => c.type === 'signature');
                if (sigCols.length > 0 && Array.isArray(v)) {
                    let changed = false;
                    const rows = v.map((row) => {
                        if (!row || typeof row !== 'object')
                            return row;
                        let rowChanged = false;
                        const cloned = { ...row };
                        for (const col of sigCols) {
                            if (cloned[col.id] === oldId) {
                                cloned[col.id] = newId;
                                rowChanged = true;
                            }
                        }
                        if (rowChanged)
                            changed = true;
                        return rowChanged ? cloned : row;
                    });
                    if (changed)
                        next[field.id] = rows;
                }
            }
        }
    }
    return next;
}
//# sourceMappingURL=replaceFileIdInData.js.map